import React from "react"
import { Image } from "semantic-ui-react";

const Badge = ( { product, height = 40 } ) => {
  // let out = []
  // if (product.extraValue.neuh === "J") {
  //   out.push(<div key={1} className="badge badge--neu"><span>NEU</span></div>)
  // }
  // if (out.length > 0) return <div className="badges">{out}</div>
  return <div className="badges nh-1 flex flex-row items-center">
    {product.extraValue.neuh === "J" && <div className="badge f7 badge--neu">NEU</div>}
    {product.extraValue.alter === "J" && <div className="badge f7 badge--alter">ab 18</div>}
    
    {product.extraValue.GreenLabel === "1" && <div title={"Green Label"} className="badge tc f7  white"><Image height={height} src={"/image/badge/Icon Green Label.png"}/></div>}
    {product.extraValue.BannerNeu === "1" && <div title={"Neu!"} className="badge tc f7  white"><Image height={height} src={"/image/badge/Icon Neu.png"}/></div>}
    {product.extraValue.BannerAngebot === "1" && <div title={"Sale!"} className="badge tc f7  white"><Image height={height} src={"/image/badge/Icon Angebot.png"}/></div>}
  </div>
}

export const PillBadges = ( { product } ) => {
  
  return (
    <div>
      {product.extraValue.neuh === "J" && <div className="pill-badge pill-badge--limitiert">NEU</div>}
      {product.extraValue.alter === "J" && <div className="pill-badge pill-badge--alter">ab 18</div>}
    </div>
  )
}

export default Badge



// WEBPACK FOOTER //
// ./src/theme/orfix-test/components/Product/Badge.js